export default __webpack_public_path__ + "static/media/Type-C.314454a8.jpg";